"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MtaPriceOutputWidget = void 0;
var React = require("react");
var PremiumOutputWidget_1 = require("./PremiumOutputWidget");
var commonFunctions_1 = require("../../commonFunctions");
var components_1 = require("@athena-portal/components");
var MtaPriceOutputWidget = /** @class */ (function (_super) {
    __extends(MtaPriceOutputWidget, _super);
    function MtaPriceOutputWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showAdditionalPremium = function () {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { id: "price", className: "price" }, (0, commonFunctions_1.getAmountToDisplay)(_this.props.interaction.factors.additionalPremium)),
                React.createElement("p", { className: "premium-type" }, "Payment amount")));
        };
        _this.showRefundPremium = function () {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { id: "price", className: "price" }, (0, commonFunctions_1.getAmountToDisplay)(_this.props.interaction.factors.returnPremium)),
                React.createElement("p", { className: "premium-type" }, "Refund amount")));
        };
        _this.showNoExtraPaymentForTheChange = function () {
            return (React.createElement(React.Fragment, null,
                React.createElement("p", { className: "premium-type" }, "Good news, there is no extra cost for the change you made!")));
        };
        _this.showPremium = function () {
            var _a = _this.props.interaction.factors, returnPremium = _a.returnPremium, additionalPremium = _a.additionalPremium;
            if (returnPremium === 0 && additionalPremium === 0) {
                return _this.showNoExtraPaymentForTheChange();
            }
            else {
                if (additionalPremium && additionalPremium > 0) {
                    return _this.showAdditionalPremium();
                }
                if (returnPremium && returnPremium > 0) {
                    return _this.showRefundPremium();
                }
            }
            return;
        };
        _this.showPriceCouldGoUpOrDown = function () {
            var neverHigherAmount = (0, commonFunctions_1.getNeverHigherPeriodAmount)(_this.props.interaction);
            return (React.createElement(React.Fragment, null,
                React.createElement("div", null,
                    React.createElement("p", { className: "text-center mx-4 mb-0" }, "Your price could go up or down after this \u2013 but we guarantee you won't pay more than"),
                    React.createElement("div", { className: "price text-center font-weight-bold font-family-display text-blue-1" }, (0, commonFunctions_1.getAmountToDisplay)(_this.props.interaction.factors.neverHigher)),
                    React.createElement("p", { className: "text-center mx-4 mb-0" }, (0, commonFunctions_1.getNeverHigherPeriodWording)(_this.props.interaction, neverHigherAmount, _this.state.policies)))));
        };
        return _this;
    }
    MtaPriceOutputWidget.prototype.render = function () {
        if (this.state.policies && this.state.subscription) {
            return (React.createElement("div", { className: "premium-output" },
                React.createElement("div", { className: "top-section" },
                    React.createElement("div", { className: "premium-info" }, this.showPremium())),
                React.createElement("div", { className: "bottom-section" }, this.showPriceCouldGoUpOrDown())));
        }
        else {
            return React.createElement(components_1.Overlay, { show: true });
        }
    };
    return MtaPriceOutputWidget;
}(PremiumOutputWidget_1.PremiumOutputWidget));
exports.MtaPriceOutputWidget = MtaPriceOutputWidget;
//# sourceMappingURL=mtaPriceOutputWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/mtaPriceOutputWidget.js
// module id = 1079
// module chunks = 0